module.exports = __webpack_public_path__ + "img/denmark-neoplasm-female.82c379b1.png";